import React, { useRef, SetStateAction, Dispatch } from "react";
import styled from "styled-components";
import { StyledNavLink, StyledNavLinkHref } from "./menu-navigation";
import { COLOR_BACKGROUND_MENU, COLOR_BLUE } from "../constants/colors";
import { ADMINISTRATEUR, FRAIS, HOME, MANDAT } from "../constants/menu";

const Wrapper = styled.div`
  .mobile {
    display: flex;
    flex-direction: column;
    position: fixed;
    z-index: 99;
    left: 0px;
    bottom: 0px;
    overflow: auto;
    font-size: 16px;
    top: ${(props) => props.itemProp}px;
    background-color: ${COLOR_BACKGROUND_MENU};
    padding: ${(props) => props.itemProp} 20px;
    min-height: 100vh;
    box-shadow: 0px 0px 2px #888888a2;
    transition: all ease 0.3s;
  }
`;

const MenuUtils = styled.p`
  margin-left: 14px;
  margin-top: 32px;
  text-decoration: underline;
`;

const SubLink = styled.a`
  font-style: normal;
  margin: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${COLOR_BLUE};
  text-decoration: none;
  font-weight: bold;
  font-size: 14px;
`;

const MenuMobile = ({
  burgerOpen,
  _setBurgerOpen,
  headerHeight,
}: {
  burgerOpen: boolean;
  _setBurgerOpen: Dispatch<SetStateAction<boolean>>;
  headerHeight: number;
}) => {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <Wrapper itemProp={headerHeight.toString()}>
      {burgerOpen && (
        <div className="mobile" ref={ref}>
          <StyledNavLinkHref
            href={HOME}
          >
            Accueil
          </StyledNavLinkHref>
          <StyledNavLink
            to={"/offres"}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Nos offres
          </StyledNavLink>
          <StyledNavLink
            to={"/location-vente"}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Location / Vente
          </StyledNavLink>
          <StyledNavLink
            to={"/demande-de-devis"}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Confier mon bien / Devis en ligne
          </StyledNavLink>
          <StyledNavLink
            to={"/partenaire"}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Devenir Partenaire
          </StyledNavLink>
          <StyledNavLink
            to={MANDAT}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Mandat de gestion locative
          </StyledNavLink>
          <StyledNavLink
            to={FRAIS}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Frais de gestion locative
          </StyledNavLink>
          <StyledNavLink
            to={ADMINISTRATEUR}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Administrateur de biens
          </StyledNavLink>
          <StyledNavLink
            to={"/contact"}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Nous contacter
          </StyledNavLink>
          <StyledNavLink
            to={"/espace-presse"}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Espace Presse
          </StyledNavLink>
          <StyledNavLink
            to={"/espaceclient"}
            className={({ isActive }) => (isActive ? "active" : "inactive")}
          >
            Espace Clients
          </StyledNavLink>

          <MenuUtils>Documents utiles :</MenuUtils>
          <SubLink href="/fichiers/attestationdhebergement.pdf" target="_blank">
            - Attestation d'hébergement
          </SubLink>
          <SubLink href="/fichiers/changementdadresse.pdf" target="_blank">
            - Changement d'adresse
          </SubLink>
          <SubLink
            href="/fichiers/courrier-resiliation-mandat-de-gestion.pdf"
            target="_blank"
          >
            - Resiliation mandat de gestion
          </SubLink>
          <SubLink
            href="/fichiers/explication-compte-rendu-de-gerance-immo-online.pdf"
            target="_blank"
          >
            - Explication compte rendu de gérence
          </SubLink>
          <SubLink
            href="/fichiers/formalitespourdemenagement.pdf"
            target="_blank"
          >
            - Formalités pour déménagement
          </SubLink>
          <SubLink href="/fichiers/la_consommation_d_eau.pdf" target="_blank">
            - La consommation d'eau
          </SubLink>
          <SubLink href="/fichiers/le_degat_des_eaux.pdf" target="_blank">
            - Le dégat des eaux
          </SubLink>
          <SubLink
            href="/fichiers/le_tri_des_dechets_menagers.pdf"
            target="_blank"
          >
            - Le tri des déchets ménagers
          </SubLink>
          <SubLink href="/fichiers/les_bruits_du_voisinage.pdf" target="_blank">
            - Les bruits du voisinage
          </SubLink>
          <SubLink href="/fichiers/les_charges_locatives.pdf" target="_blank">
            - Les charges locatives
          </SubLink>
          <SubLink
            href="/fichiers/les_reparations_locatives.pdf"
            target="_blank"
          >
            - Les réparations locatives
          </SubLink>
          <SubLink
            href="/fichiers/pourquoifairegerersonbienimmobilier.pdf"
            target="_blank"
          >
            - Pourquoi faire gérer son bien immobilier
          </SubLink>
        </div>
      )}
    </Wrapper>
  );
};

export default MenuMobile;
